import Mousetrap from 'mousetrap'
import globalBindPlugin from './plugins/global-bind'
import pausePlugin from './plugins/pause'
import bindDictionaryPlugin from './plugins/bind-dictionary'
import backspacePreventNavigation from './plugins/backspace-prevent-navigation'
import inputSubmitHandlingPlugin from './plugins/input-sumbit-handling'

globalBindPlugin(Mousetrap)
pausePlugin(Mousetrap)
bindDictionaryPlugin(Mousetrap)
backspacePreventNavigation(Mousetrap)
inputSubmitHandlingPlugin(Mousetrap)

export default Mousetrap
